/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputGeoReverse
 */
export interface OutputGeoReverse {
    /**
     * Labels — по одному елементу на кожну передану точку; порожній рядок = поблизу нічого
     * не знайдено.
     * @type {Array<string>}
     * @memberof OutputGeoReverse
     */
    labels?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OutputGeoReverse
     */
    route?: string;
}

/**
 * Check if a given object implements the OutputGeoReverse interface.
 */
export function instanceOfOutputGeoReverse(value: object): boolean {
    return true;
}

export function OutputGeoReverseFromJSON(json: any): OutputGeoReverse {
    return OutputGeoReverseFromJSONTyped(json, false);
}

export function OutputGeoReverseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoReverse {
    if (json == null) {
        return json;
    }
    return {
        
        'labels': json['labels'] == null ? undefined : json['labels'],
        'route': json['route'] == null ? undefined : json['route'],
    };
}

export function OutputGeoReverseToJSON(value?: OutputGeoReverse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'labels': value['labels'],
        'route': value['route'],
    };
}

